import { component$, type JSX, useContext } from '@builder.io/qwik';
import { ArticleContext } from '~/contexts/ArticleContext';
import Tag from '~/components/Shared/Tags/Tag';
import TagCarousel from '~/components/Shared/Tags/TagCarousel';

export default component$((): JSX.Element => {
  const article = useContext(ArticleContext);

  return (
    <div class='mt-8 md:mt-0'>
      {!!article?.inThisStory?.length && (
        <div class='mb-8'>
          <p class='font-group-tiny mb-4'>In this story:</p>
          <TagCarousel>
            {article.inThisStory.map((each) => {
              return (
                <Tag key={each.slug} link={each.link} text={each.displayName} />
              );
            })}
          </TagCarousel>
        </div>
      )}
    </div>
  );
});
